/* @flow */
export const LOGICAL_TYPE = {
  SCALAR: 'scalar',
  EPOCH: 'timestamp-millis',
  OBJECT: 'object',
  COUNTRY_CODE: 'country_code',
};

export const NON_LOGICAL_TYPE = {
  ENCLAVE_ICON_LIST: 'enclave-icon-list'
};

export const ExtractedEntitySortOptions = [
  {
    text: 'Type',
    sort: {
      sortBy: 'indicatorType',
      sortDirection: 'ASC'
    }
  },
  {
    text: 'Name',
    sort: {
      sortBy: 'value',
      sortDirection: 'ASC'
    }
  },
  {
    text: 'Has Score',
    sort: {
      sortBy: 'hasScore',
      sortDirection: 'ASC'
    }
  }
];

export const ENCLAVE_MAPPING_FOR_CS_ENDPOINT = '/services/entity-reports/source-mappings'
export const FETCH_SUMMARIES_ENDPOINT = '/services/entity-reports/summaries';



// WEBPACK FOOTER //
// ./src/app/modules/summaries/constants.js